import React from 'react';
export function KitContentsSection() {
  const contents = [{
    emoji: '📅',
    title: '6 Volumi Annuali',
    desc: 'Un anno intero di lezioni pianificate, settimana per settimana.'
  }, {
    emoji: '🌿',
    title: 'Yoga Terapeutico',
    desc: 'Protocolli per i disturbi più comuni: ansia, sonno, schiena, cervicale.'
  }, {
    emoji: '🪷',
    title: 'Filosofia & Temi',
    desc: 'Spunti e temi pronti da portare in aula ogni settimana.'
  }, {
    emoji: '🌊',
    title: "Vinyasa / L'Arte del Flow",
    desc: 'Sequenze fluide e professionali già costruite per te.'
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-97">
      <div className="max-w-5xl mx-auto" data-id="element-98">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text text-center mb-16" data-id="element-99">
          📦 Cosa contiene il Kit Yoga Pronta?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-100">
          {contents.map((item, i) => <div key={i} className="bg-[#f9f5ef] rounded-3xl p-8 text-center border border-brand-creamDark/50 shadow-sm" data-id="element-101">
              <div className="text-4xl mb-4" data-id="element-102">{item.emoji}</div>
              <h3 className="text-xl font-serif font-bold text-brand-text mb-2" data-id="element-103">
                {item.title}
              </h3>
              <p className="text-brand-gray text-sm" data-id="element-104">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}